import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { yandexHit, googleHit } from 'cityads-v3/utils/counterUtils';

export class NavigationCounter extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { location: prevLocation } = prevProps;

    if (location !== prevLocation) {
      const newUrl = location ? location.pathname + location.search + location.hash : null;
      const oldUrl = prevLocation ? prevLocation.pathname + prevLocation.search + prevLocation.hash : null;

      yandexHit(newUrl, { referer: oldUrl });
      googleHit(newUrl);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(NavigationCounter);
